



















import Vue from 'vue';
import { IProductVariant } from '../../../../common/interfaces/products.interface';

export default Vue.extend({
  name: `ProductVariantColor`,
  props: {
    active: {
      default: false,
      type: Boolean,
    },
    productVariant: {
      required: true,
      type: Object as () => IProductVariant,
    },
  },
  methods: {
    selectVariant(): void {
      if(!this.active) {
        this.$emit(`select:variant`);
      }
    },
  },
});
